import { FieldError } from 'react-hook-form';

export const getHelperText = (error?: FieldError) =>
  Array.isArray(error) ? error[error.length - 1].message : error?.message;
